import { render, staticRenderFns } from "./TitleCard.vue?vue&type=template&id=4f1701e2"
import script from "./TitleCard.vue?vue&type=script&lang=js"
export * from "./TitleCard.vue?vue&type=script&lang=js"
import style0 from "./TitleCard.vue?vue&type=style&index=0&id=4f1701e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports